import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StartPageComponent} from "./start-page.component";
import {RouterModule} from "@angular/router";
import {startPageRoutes} from "./start-page-routes";
import {SharedModule} from "../../@shared/shared.module";


@NgModule({
  declarations: [
    StartPageComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(startPageRoutes),
  ]
})
export class StartPageModule {
}
